import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Request from '../../Request';
import { buildBreadcrumbItems, getBreadcrumbRoute, loadBreadcrumbData } from './breadcrumbRoutes';
import './GlobalBreadcrumb.css';

export default function GlobalBreadcrumb({ pathname, user, token }) {
    const [resolved, setResolved] = useState(null);

    useEffect(() => {
        let active = true;
        const routeInfo = getBreadcrumbRoute(pathname);
        setResolved(null);
        loadBreadcrumbData(routeInfo, path => Request.Get(path)).then(data => {
            if (active) setResolved({ pathname, token, data });
        });
        return () => { active = false; };
    }, [pathname, token]);

    const data = resolved?.pathname === pathname && resolved?.token === token ? resolved.data : {};
    const items = buildBreadcrumbItems(getBreadcrumbRoute(pathname), user, data);
    if (!items.length) return null;

    return (
        <nav className="modern-global-breadcrumb hidethis" aria-label="Navegação estrutural">
            <ol>
                {items.map((entry, index) => (
                    <li key={`${index}-${entry.label}`}>
                        {index > 0 && <span className="breadcrumb-separator" aria-hidden="true">/</span>}
                        {entry.current
                            ? <strong aria-current="page">{entry.label}</strong>
                            : entry.path ? <Link to={entry.path}>{entry.label}</Link> : <span>{entry.label}</span>}
                    </li>
                ))}
            </ol>
        </nav>
    );
}
